/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Billing_Last_Bill_Pay_ButtonInputs */

const es_admin_billing_last_bill_pay_button = /** @type {(inputs: Admin_Billing_Last_Bill_Pay_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagar`)
};

const en_admin_billing_last_bill_pay_button = /** @type {(inputs: Admin_Billing_Last_Bill_Pay_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pay`)
};

/**
* | output |
* | --- |
* | "Pay" |
*
* @param {Admin_Billing_Last_Bill_Pay_ButtonInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_billing_last_bill_pay_button = /** @type {((inputs?: Admin_Billing_Last_Bill_Pay_ButtonInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Billing_Last_Bill_Pay_ButtonInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_billing_last_bill_pay_button(inputs)
	return en_admin_billing_last_bill_pay_button(inputs)
});
export { admin_billing_last_bill_pay_button as "admin.billing.last_bill.pay_button" }